import { render, staticRenderFns } from "./saleTextBoard.vue?vue&type=template&id=2ba41aa4&scoped=true"
import script from "./saleTextBoard.vue?vue&type=script&lang=js"
export * from "./saleTextBoard.vue?vue&type=script&lang=js"
import style0 from "./saleTextBoard.vue?vue&type=style&index=0&id=2ba41aa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba41aa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba41aa4')) {
      api.createRecord('2ba41aa4', component.options)
    } else {
      api.reload('2ba41aa4', component.options)
    }
    module.hot.accept("./saleTextBoard.vue?vue&type=template&id=2ba41aa4&scoped=true", function () {
      api.rerender('2ba41aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/saleTextBoard.vue"
export default component.exports